import { useState } from 'react'

import { Checkbox } from '../../../components/ui/form/checkbox'

type Props = {
  disabled: boolean
  initialState: boolean
  onChange: (filter: { day: number } | undefined) => void
}

function BroadcastRecentlyContacted({
  disabled,
  initialState,
  onChange,
}: Props) {
  const [checked, setChecked] = useState(initialState)

  function handleRecentlyContacted(isChecked: boolean) {
    setChecked(isChecked)

    const notContacted = isChecked ? undefined : { day: 1 }

    // save broadcast so can get updated count
    onChange(notContacted)
  }

  return (
    <div className="py-2">
      <Checkbox
        id="recentlyContacted"
        disabled={disabled}
        checked={checked}
        label="Include Clients Contacted in Last 24 Hours"
        onChange={handleRecentlyContacted}
      />
    </div>
  )
}

export { BroadcastRecentlyContacted }
